import {z} from 'zod'
import {parseAxiosPromise} from '@/axiosInstance'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {useInputSearch} from '@/hooks/useInputSearch'
import {httpGetMedicalReportTypes} from '@/features/medical-reports/http/medicalReports.http'
import {MedicalReportTypeGroup} from '@/features/medical-reports/types'

export const ResponseShape = z.array(MedicalReportTypeGroup)
export type ResponseShape = z.infer<typeof ResponseShape>

export const useGetMedicalReportTypes = ({
    search,
    options
}: {
    search?: string
    options?: Omit<UseQueryOptions<ResponseShape>, 'queryKey' | 'queryFn'>
}) => {
    const {searchValue, onSearch, onResetSearch} = useInputSearch()

    const query = useQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORTS, search ?? searchValue],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetMedicalReportTypes({
                    search: search ?? searchValue
                }),
                responseShape: ResponseShape,
                onZodError: captureException
            }),
        ...options
    })

    return {
        ...query,
        searchValue,
        onResetSearch,
        onSearch
    }
}
